namespace JupitersChoice {
    export class ReShowJupiterCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;

        execute(): void {
            this._componentManager.get('JupiterBaseGame').show();
        }
    }
}